import userService from 'services/userData';
import companyInfoService from 'services/companyInfo';
import { parseParamsForURL } from 'services/utils/urlParams';
import auth from 'services/auth';

const KCIronAllUsers = 'http://developers.ironsrc.com';
const contactUsUrl = 'https://ironsrc.formtitan.com/contact-us';

export default Object.freeze({
    contactUsLink: contactUsUrl,
    rate: `${KCIronAllUsers}/ironsource-mobile/air/mediation-management-3/`,
    termsNewUser: 'https://platform.ironsrc.com/partners/terms-and-conditions-new-user',
    termsAndConditions: 'https://platform.ironsrc.com/partners/terms-and-conditions',
    integrationTesting: `${KCIronAllUsers}/ironsource-mobile/air/integration-testing`,
    termsAdvertisers: 'https://platform.ironsrc.com/partners/terms-and-conditions-user-acquisition',
    ironsrc: 'https://www.ironsrc.com/',
    knowledgeCenter: KCIronAllUsers,
    segments: `${KCIronAllUsers}/segments/`,
    segmentsSetup: `${KCIronAllUsers}/ironsource-mobile/general/segments-set-up/`,
    levelPlay: `${KCIronAllUsers}/ironsource-mobile/air/level-play`,
    biddingTest: `${KCIronAllUsers}/ironsource-mobile/air/bidding-test-2/`,
    abTesting: `${KCIronAllUsers}/ironsource-mobile/air/ab-testing/`,
    quickABTest: `${KCIronAllUsers}/ironsource-mobile/general/quick-ab-test/`,
    cvManager: `${KCIronAllUsers}/ironsource-mobile/air/ad-revenue-conversion-value-manager`,
    downloadSDKUrl: `${KCIronAllUsers}/download-ironsource-sdk/`
});

export async function getContactUsUrl(onBoarding = false, categoryValue = '') {
    const { userEmail, contactUsHash } = await userService.getUserData();
    const isAdmin = await auth.isAuthorized(['admin']);
    const isTester = await auth.isAuthorized(['monetizerTester']);
    let monetizerContactName = '';
    if (!isAdmin && !isTester) {
        const companyInfo = await companyInfoService.getCompanyInfo(['monetizerContactName']);
        if (companyInfo && companyInfo.monetizerContactName) {
            monetizerContactName = companyInfo.monetizerContactName;
        }
    }
    const userInfo = {
        fld2: userEmail,
        fld3: monetizerContactName,
        fld40: contactUsHash,
        fld4: categoryValue,
        fld79: onBoarding || false
    };

    const params = parseParamsForURL(userInfo);
    return `${contactUsUrl}?${params}`;
}
